import type { RouteRecordRaw } from 'vue-router'

import { AdokLayout as Layout } from '@/apps/adok/app/layout'
import { readStaffBadge } from '@/apps/adok/entities/account'

const MasterSpotCheckPage = () =>
  import('@/apps/adok/pages/master-spot-check').then(
    (m) => m.MasterSpotCheckPage
  )

const masterSpotCheckRoutes: RouteRecordRaw[] = [
  {
    path: '/master-spot-check',
    component: Layout,
    children: [
      {
        path: '',
        name: 'master-spot-check',
        component: MasterSpotCheckPage,
        beforeEnter: () =>
          readStaffBadge().isStaff ? true : { name: 'dashboard' },
        meta: {
          title: 'Live ad test'
        }
      }
    ]
  }
]

export default masterSpotCheckRoutes
